import { h } from 'preact';

import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import AppBar from '@mui/material/AppBar';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';

import styles from '../../components/global.css';
import { Skeleton } from '@mui/material';
import { IssueTable } from './_common.jsx';
import LazyLcpIssueRecord from '../../components/lcpIssueRecord/lazyLcpIssueRecord.jsx';

function LazyRpmUrlDetails(_props) {
  return (
    <>
      <AppBar
        position="static"
        color="transparent"
        elevation={0}
        sx={{ mt: -4 }}
      >
        <Skeleton width={'100%'} height={48} />
      </AppBar>

      <Paper className={styles.originArea}>
        <Skeleton width={'100%'} height={72} />
      </Paper>

      <Paper className={`${styles.originArea}`}>
        <div className={styles.dateHolder}>
          <Typography variant="h6">Timeline</Typography>
          <Skeleton width={580} height={58} />
        </div>

        <Paper className={`${styles.reportArea}`}>
          <Typography variant="h6">UX Distribution</Typography>
          <Skeleton width={'100%'} height={478} />
        </Paper>

        <Paper className={`${styles.reportArea}`}>
          <Typography variant="h6">P75 Value</Typography>
          <Skeleton width={'100%'} height={478} />
        </Paper>
      </Paper>

      <div className={`${styles.rpmReportArea}`}>
        <Card>
          <CardActions>
            <Typography variant="h5">Latest issues found on URL</Typography>
            <Skeleton width={180} height={48} sx={{ marginLeft: 'auto' }} />
          </CardActions>
          <CardContent>
            <IssueTable>
              {Array(10)
                .fill(null)
                .map((_, index) => (
                  <LazyLcpIssueRecord key={index} />
                ))}
            </IssueTable>
          </CardContent>
        </Card>
      </div>
    </>
  );
}

export default LazyRpmUrlDetails;
